import {Configuration} from '@shipwell/backend-core-singlerequestparam-sdk';
import {basePath} from 'App/api/config';
import {getAccessToken} from 'App/api/utils';

export const configuration = new Configuration({
  basePath,
  apiKey: getAccessToken
});
